import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, TemplateRef, ViewChild } from '@angular/core';

import { EnumEventTheme } from '../../../../shared/constants/event-theme.constant';
import { EventThemeHelper } from '../event-theme.helper';
import { IEventThemeConfig } from '../event-theme.data';
import { EnumBannerType, EnumEventBanner, EVENT_BANNER_THEMES, IEventBannerTheme } from './event-banner.data';


@Component({
    selector: 'app-event-banner',
    templateUrl: './event-banner.component.html',
    styleUrls: ['./event-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EventBannerComponent implements AfterViewChecked {

	@ViewChild('bannerTypeDiscount') 	bannerTypeDiscount	!: TemplateRef<any>;
	@ViewChild('bannerTypeMascot') 		bannerTypeMascot	!: TemplateRef<any>;
	@ViewChild('bannerTypeMessage') 	bannerTypeMessage	!: TemplateRef<any>;

	//** Input parameters */
	@Input() eventTheme		: EnumEventTheme | null = null;
	@Input() imgWidthInPx	: number		 = 100;
	@Input() textWidthInPx	: number		 = 120;

	//** Helper Variables */
	bannerTheme		: IEventBannerTheme | null = null;
	validity		: Date				= new Date();
	bannerTemplate !: TemplateRef<any>;

	constructor(
		private eventThemeHelper: EventThemeHelper,
		private cdr				: ChangeDetectorRef
	) {}


	ngAfterViewChecked(): void {

		//0 - get event theme
		const eventTheme: IEventThemeConfig | null = this.eventThemeHelper.getCurrentEventTheme(this.eventTheme);

		//1 - check if event theme exists
		if (!eventTheme || eventTheme?.view?.banner === EnumEventBanner.None) return;

		//2 - get event validity and banner theme
		this.validity	 = this.eventThemeHelper.getDateWithCurrentYear(eventTheme.condition.schedule!.end);
		this.bannerTheme = this.getBannerTheme(eventTheme.view.banner!);
		this.bannerTemplate = this.getBannerTemplate(this.bannerTheme);
		this.cdr.detectChanges();
	}

	//** Get Banner theme */
	private getBannerTheme(banner: EnumEventBanner): IEventBannerTheme {

		//0 - find banner theme according to the event banner
		const bannerTheme: IEventBannerTheme | undefined = EVENT_BANNER_THEMES.find((theme: IEventBannerTheme) => theme.code === banner);

		//1 - check if event banner is supported or not
		if (!bannerTheme) throw new Error(`EventBannerComponent => getBannerTheme => FATAL ERROR: ${bannerTheme} is not supported.`);
		return bannerTheme;
	}

	//** Get banner template */
	private getBannerTemplate(bannerTheme: IEventBannerTheme) {

		switch (bannerTheme.content.bannerType) {

			case EnumBannerType.Discount:
				return this.bannerTypeDiscount;

			case EnumBannerType.Mascot:
				return this.bannerTypeMascot;

			case EnumBannerType.Message:
				return this.bannerTypeMessage;

			default:
				throw new Error(`EventBannerComponent => getBannerTemplate => FATAL ERROR: ${(bannerTheme.content as any).bannerType} is not supported.`);
		}
	}
}
